import React from 'react';
import ErrorGeneric from 'components/Error/ErrorGeneric';
import { withLocale } from '@dietlabs/components';

const ErrorApplication = props => <ErrorGeneric topLevel {...props} />;

export default withLocale(ErrorApplication);
